import logo from '@/assets/logo.png'

import { useFloatMenu } from '@/hooks/useFloatMenu'
import { ReduxProps } from '@/storage'
import { AdminDataProps } from '@/storage/modules/admin/reducer'

import { IoCloseOutline, IoMenuOutline, IoPerson } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import colors from 'tailwindcss/colors'

interface HeaderProps {
  isError?: boolean
  isSideMenuOpen: boolean
  onToggleSideMenu: () => void
}

export function Header({
  isError,
  isSideMenuOpen,
  onToggleSideMenu,
}: HeaderProps) {
  const { isVisible, show } = useFloatMenu()

  const { admin } = useSelector<ReduxProps, AdminDataProps>(
    (state) => state.admin,
  )

  return (
    <div className="fixed z-50 flex h-20 w-full items-center justify-between bg-gray-700 px-10 py-5 shadow-xl shadow-black/10 base:px-6 md:px-4">
      <div className="flex items-center gap-3">
        {!isError && (
          <button
            aria-label={isSideMenuOpen ? 'Close side menu' : 'Open side menu'}
            className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/8 text-white/90 opacity-80 transition hover:bg-white/15 hover:opacity-100"
            onClick={onToggleSideMenu}
            title={isSideMenuOpen ? 'Close side menu' : 'Open side menu'}
          >
            {isSideMenuOpen ? (
              <IoCloseOutline size={24} />
            ) : (
              <IoMenuOutline size={24} />
            )}
          </button>
        )}

        <img src={logo} alt="logo" className="w-32 md:w-28" />
      </div>

      {!isError && (
        <button
          className="w-12 h-12 bg-purple-600 items-center flex justify-center cursor-pointer rounded-full overflow-hidden"
          onClick={() => {
            show(!isVisible)
          }}
        >
          {admin.photoURL ? (
            <img src={admin.photoURL} alt="user pic" />
          ) : (
            <IoPerson color={colors.gray[200]} />
          )}
        </button>
      )}
    </div>
  )
}
